export enum DayFormatOption {
	Short = 'short',
	Long = 'long',
	Narrow = 'narrow',
}
